<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :return-value.sync="dateValue"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="dateValue"
        :label="label"
        prepend-icon="mdi-calendar"
        readonly
        v-bind="attrs"
        :rules="[datesValidation]"
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="dateValue"
      no-title
      scrollable
      locale="jp-ja"
      :day-format="(date) => new Date(date).getDate()"
      style="height: 300px;"
      @input="$refs.menu.save(dateValue)"
    >
    </v-date-picker>
  </v-menu>
</template>

<script>
import moment from 'moment'

export default {
  name: 'InputDate',
  props: {
    value: Date,
    label: String
  },
  data: function () {
    return {
      dateValue: this.initializeDateValue(),
      menu: false,
      modal: false,
      datesValidation: (value) => {
        if (!value) {
          return '必須入力項目です'
        } else {
          return true
        }
      }
    }
  },
  computed: {
    computedDateFormatted () {
      return this.formatDate(this.dateValue)
    }
  },
  watch: {
    dateValue () {
      this.$emit('input', moment(this.dateValue).toDate())
    }
  },
  methods: {
    initializeDateValue () {
      if (this.value) return this.value.toISOString().substr(0, 10)
      return null
    }
  }
}
</script>
